import { onMounted, onUnmounted, ref, watch } from "vue";
import { useTimelineMapStore } from "../../store/timelineMapStore";
import {
  randomizeIconPositions,
  setRandomFadePositionOnAllIcons,
  fadeTimeline,
  fadeTimelineIcons,
} from "../../services/vrak/timelineIconsService";
import timelineRandomVisualEffectService
  from "@features/Pages/TimelineMapPage/_js/app/services/vrak/timelineRandomVisualEffectService";

export function useTimelineEffects() {
  const store = useTimelineMapStore();
  const windowWidthInitialValue = ref(window.innerWidth);
  const eventsInitialized = ref(false);

  function resizeEvent() {
    if (windowWidthInitialValue.value !== window.innerWidth) {
      randomizeIconPositions();

      document.querySelectorAll<HTMLElement>(".epoch").forEach((epochElement) => {
        const listOfIcons =
          epochElement.querySelectorAll<HTMLElement>(".timeline-icon");
        listOfIcons.forEach((icon, index) => {
          icon.style.left =
            timelineRandomVisualEffectService.getRandomLeftPosition(
              index < listOfIcons.length / 2
            ) + "px";
          icon.style.top =
            timelineRandomVisualEffectService.getRandomTopPosition() + "px";
        });
      });
    }

    setRandomFadePositionOnAllIcons();
    windowWidthInitialValue.value = window.innerWidth;
  }

  onMounted(() => {
    randomizeIconPositions();
    setRandomFadePositionOnAllIcons();
    fadeTimeline();
    fadeTimelineIcons();
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", fadeTimelineIcons);
    window.removeEventListener("scroll", fadeTimeline);
    window.removeEventListener("resize", resizeEvent);
  });

  watch(
    () => store.epochs,
    (newEpochs) => {
      if (!eventsInitialized.value && newEpochs.length > 0) {
        randomizeIconPositions();
        setRandomFadePositionOnAllIcons();
        fadeTimeline();
        fadeTimelineIcons();

        window.addEventListener("scroll", fadeTimelineIcons);
        window.addEventListener("scroll", fadeTimeline);
        window.addEventListener("resize", resizeEvent);

        eventsInitialized.value = true;
      }
    },
    { immediate: true }
  );
}